import React from 'react';
import { ICONS } from '@/constants/constants';
import Image from 'next/image';
import { CustomButton } from '@/components/atomic';
import { googleAuth, appleAuth, facebookAuth } from '@/lib/api/social-auth';

const SocialLogins = () => {
  const handleSocialLogin = (provider: string) => {
    switch (provider) {
      case 'google':
        googleAuth();
        break;
      case 'apple':
        appleAuth();
        break;
      case 'facebook':
        facebookAuth();
        break;
      default:
        return;
    }
  };

  const socialButtons = [
    { id: 'google', icon: ICONS.google },
    { id: 'facebook', icon: ICONS.facebook },
    { id: 'apple', icon: ICONS.apple },
  ];

  return (
    <div className="w-full font-sans">
      {/* Divider with text */}
      <div className="flex items-center my-4">
        <div className="grow h-px bg-gray-300"></div>
        <span className="px-4 text-lg text-gray-500 work_sans">or continue with</span>
        <div className="grow h-px bg-gray-300"></div>
      </div>
      
      {/* Social login buttons */}
      <div className="flex gap-2 mt-4">
        {socialButtons.map((button) => (
          <CustomButton 
            key={button.id}
            onClick={() => handleSocialLogin(button.id)}
            className="flex-1 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            <Image src={button.icon} alt={button.id} width={20} height={20} />
          </CustomButton>
        ))}
      </div>
    </div>
  );
};

export default SocialLogins;